// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
// import "./permission"
// ElementUI
import ElementUI from 'element-ui'
Vue.use(ElementUI)
// 组件
import components from '@/components/index.js'
Vue.use(components)
// 样式
import '@/styles/index.js'
import '@/assets/iconfront/iconfont.css'
import '@/assets/iconfront/iconfont.js'


import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上

//混入
import mixins from '@/common/mixin/index.js';
Vue.use(mixins);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js